const colorPallete = {
  // red
  alpha100: '#ffe6e6',
  alpha200: '#ffcccc',
  alpha300: '#ffb3b3',
  alpha400: '#ff9999',
  alpha500: '#ff8080',
  alpha600: '#ff6666',
  alpha700: '#ea4335',
  alpha800: '#ff3333',
  alpha900: '#ff0000',

  // orange
  beta100: '#ffebcc',
  beta200: '#ffd9b3',
  beta300: '#ffc699',
  beta400: '#ffb380',
  beta500: '#ffa366',
  beta600: '#ff8f4d',
  beta700: '#f6892a',
  beta800: '#e1750b',
  beta900: '#d46a02',

  // blue
  gamma100: '#b2ddff',
  gamma200: '#7dace8',
  gamma300: '#4cb5f5',
  gamma400: '#2196f3',
  gamma500: '#1890ff',
  gamma600: '#0050ff',
  gamma700: '#0000e6',
  gamma800: '#1c4e80',
  gamma900: '#39393d',

  // lightblue
  delta100: '#f0f8ff',
  delta200: '#e0f1ff',
  delta300: '#c0e0ff',
  delta400: '#a0c8ff',
  delta500: '#80b0ff',
  delta600: '#6095ff',
  delta700: '#2f72d1',
  delta800: '#0076c6',
  delta900: '#2b6eda',

  // green
  epsilon100: '#ecfdf3',
  epsilon200: '#abe5a1',
  epsilon300: '#00ff00',
  epsilon400: '#00e396',
  epsilon500: '#17b26a',
  epsilon600: '#079455',
  epsilon700: '#189f00',
  epsilon800: '#008000',
  epsilon900: '#106f00',

  // yellow
  zeta100: '#ffffe6',
  zeta200: '#ffffcc',
  zeta300: '#ffffb3',
  zeta400: '#ffff99',
  zeta500: '#edec76',
  zeta600: '#ffff80',
  zeta700: '#ffff66',
  zeta800: '#fdd835',
  zeta900: '#d0b41c',

  // brown
  eta100: '#f5e8d1',
  eta200: '#e8d3b4',
  eta300: '#d2b48c',
  eta400: '#bc9b6f',
  eta500: '#a57a4b',
  eta600: '#8e5c37',
  eta700: '#704f26',
  eta800: '#59422a',
  eta900: '#3d2b1f',

  // cyan
  theta100: '#e0ffff',
  theta200: '#b3ffff',
  theta300: '#80ffff',
  theta400: '#66ffff',
  theta500: '#33ffff',
  theta600: '#00e6e6',
  theta700: '#00b3b3',
  theta800: '#009999',
  theta900: '#007f7f',

  // white
  lota100: '#f9f9f9',
  lota200: '#f1f1f1',
  lota300: '#f2f2f2',
  lota400: '#e9e9e9',
  lota500: '#f5f5f5',
  lota600: '#dcdcdc',
  lota700: '#f0eae5',
  lota800: '#fffff2',
  lota900: '#ffffff',

  // black
  kappa100: '#0000000a',
  kappa200: '#00000019',
  kappa300: '#0000003b',
  kappa400: '#00000080',
  kappa500: '#111',
  kappa600: '#070707',
  kappa700: '#000000',
  kappa800: '#0000003b',
  kappa900: '#1018280d',

  // grey
  lambda100: '#fafafa',
  lambda200: '#f2f4f8',
  lambda300: '#efefef',
  lambda400: '#e2e2e2',
  lambda500: '#e0e0e0',
  lambda600: '#d3d3d3',
  lambda700: '#c8c8c8',
  lambda800: '#888888',
  lambda900: '#484848',
  binGrey: '#9999a1',

  // megenta
  mu100: '#d8bfd8',
  mu200: '#ffb3d9',
  mu300: '#ff80c1',
  mu400: '#ff4da9',
  mu500: '#ff1a91',
  mu600: '#e6007a',
  mu700: '#b3005c',
  mu800: '#80003f',
  mu900: '#4d0021',

  // warehouse-layout
  conveyorColor: '#153047',
  cylinderColor: '#768092',
  loaderBlack: '#FFFFFF80',
  gradient: 'linear-gradient(90deg, #353839 50%, transparent 50%)',
  grayWhiteGradient: 'linear-gradient(90deg, #fafafa 10%,#DBDBDB54 50%, #DBDBDB17 100%);',
  aisleMetal: '#0000bb',
  aislePallet: '#bd975e',
  aislePalletStand: '#9d6934',

  // Robotics
  blackOpacity: '#00000030',
  whiteOpacity: 'ffffffa8',
};

export default colorPallete;
